import { render, staticRenderFns } from "./ProfileNavigation.vue?vue&type=template&id=70e16bd2&"
import script from "./ProfileNavigation.vue?vue&type=script&lang=js&"
export * from "./ProfileNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70e16bd2')) {
      api.createRecord('70e16bd2', component.options)
    } else {
      api.reload('70e16bd2', component.options)
    }
    module.hot.accept("./ProfileNavigation.vue?vue&type=template&id=70e16bd2&", function () {
      api.rerender('70e16bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/ProfileNavigation.vue"
export default component.exports